import { usePrefetch } from "@/hooks/usePrefetch";

/**
 * Component that triggers prefetching of essential data.
 * Should be placed inside QueryClientProvider but doesn't render anything.
 */
const PrefetchProvider = () => {
  usePrefetch();
  return null;
};

export default PrefetchProvider;
